import { App } from './App';
import { BaseAppPlugin } from '@scarybeasties/phaser-framework-core';

export class AppPlugin extends BaseAppPlugin {
  protected declare app: App;

  public init(data: App): void {
    this.app = data;
  }

  // get Config(): BootConfig {
  //   return this.app.Config;
  // }
}
